import { useEffect, useState } from "react";

const slides = [
  {
    src: "/images/arquitectura-residencial-gran-canaria-afgestiones.jpg",
    alt: "Entorno residencial urbano y comunidades de propietarios gestionadas en Gran Canaria - AFGestiones",
    title: "Fotografía: Archivo Corporativo AFGestiones - Entornos residenciales en Gran Canaria",
  },
  {
    src: "/images/edificio.jpg",
    alt: "Detalle arquitectónico cálido con madera, balcones y vegetación cuidada en comunidad residencial",
    title: "Fotografía: Archivo Corporativo AFGestiones - Detalle arquitectónico residencial",
  },
  {
    src: "/images/principal.jpg",
    alt: "Complejo residencial con zonas comunes cuidadas, piscina y áreas verdes en Gran Canaria",
    title: "Fotografía: Archivo Corporativo AFGestiones - Zonas comunes residenciales",
  },
];

export default function HeroCarousel() {
  const [active, setActive] = useState(0);
  const [paused, setPaused] = useState(false);
  const [reducedMotion, setReducedMotion] = useState(false);

  useEffect(() => {
    const media = window.matchMedia("(prefers-reduced-motion: reduce)");
    const updatePreference = () => setReducedMotion(media.matches);
    updatePreference();
    media.addEventListener("change", updatePreference);
    return () => media.removeEventListener("change", updatePreference);
  }, []);

  useEffect(() => {
    if (paused || reducedMotion) return undefined;
    const timer = window.setInterval(() => {
      setActive((current) => (current + 1) % slides.length);
    }, 5500);
    return () => window.clearInterval(timer);
  }, [paused, reducedMotion]);

  return (
    <div
      data-testid="hero-carousel"
      className="relative h-[260px] w-full sm:h-[220px] lg:aspect-[16/10] lg:h-[380px] lg:self-start"
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
      onFocus={() => setPaused(true)}
      onBlur={() => setPaused(false)}
    >
      <div className="relative h-full w-full overflow-hidden rounded-[14px] shadow-[0_12px_32px_-8px_rgba(0,0,0,0.12)]">
        {slides.map((slide, index) => (
          <img
            key={slide.src}
            src={slide.src}
            alt={slide.alt}
            title={slide.title}
            loading={index === 0 ? "eager" : "lazy"}
            className={`absolute inset-0 h-full w-full object-cover object-center transition-opacity duration-1000 ease-out motion-reduce:transition-none ${
              active === index ? "opacity-100" : "opacity-0"
            }`}
          />
        ))}
      </div>
      <div className="absolute bottom-4 left-1/2 flex -translate-x-1/2 items-center gap-2 rounded-full bg-white/75 px-3 py-2 backdrop-blur-sm">
        {slides.map((slide, index) => (
          <button
            key={slide.src}
            type="button"
            aria-label={`Ver imagen ${index + 1} del hero`}
            aria-pressed={active === index}
            data-testid={`hero-carousel-indicator-${index + 1}`}
            onClick={() => setActive(index)}
            className={`h-1.5 rounded-full transition-[width,background-color] duration-500 ${
              active === index ? "w-8 bg-slate-900" : "w-3 bg-slate-400/60 hover:bg-slate-600"
            }`}
          />
        ))}
      </div>
    </div>
  );
}
